import {
  createMachine,
  useIsAuthenticated,
  useSyncState,
} from "@indietabletop/appkit";
import { client } from "./client.ts";
import { database } from "./database.ts";

export const machine = createMachine({
  database,
  client,
  pullGameDataFor: "spacegits",
});

export type SyncState = ReturnType<typeof useSyncState>;

export { useIsAuthenticated, useSyncState };
